(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yumi-footer')) {
    customElements.define('yumi-footer', class extends HTMLElement {
      connectedCallback() {
        const extras = this.querySelector('.yumi-footer__extras');
        this.querySelectorAll('.yumi-footer__panel > anchored-popover-component, .yumi-footer__panel > .footer-utilities__group-copyright').forEach((block) => extras.append(block));
      }
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.yumi-footer__help[open]').forEach((menu) => {
      menu.open = false;
      if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.yumi-footer__help[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('yumi-announcement-ticker')) {
    customElements.define('yumi-announcement-ticker', class extends HTMLElement {
      connectedCallback() {
        this.observer = new ResizeObserver(() => this.refresh());
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      refresh() {
        const track=this.querySelector('.yumi-ticker__track');
        const cycle=this.querySelector('[data-original-cycle]');
        const unit=this.querySelector('[data-original-unit]');
        if (!track || !cycle || !unit) return;
        track.querySelectorAll('[data-ticker-copy]').forEach(node=>node.remove());
        const unitWidth=unit.getBoundingClientRect().width;
        if (!unitWidth) return;
        const clone=(node)=>{
          const copy=node.cloneNode(true);
          copy.removeAttribute('data-original-cycle');
          copy.removeAttribute('data-original-unit');
          copy.setAttribute('data-ticker-copy','');
          copy.setAttribute('aria-hidden','true');
          copy.setAttribute('inert','');
          copy.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
          copy.querySelectorAll('[data-shopify-editor-block]').forEach(el=>el.removeAttribute('data-shopify-editor-block'));
          return copy;
        };
        const count=Math.min(24,Math.ceil(this.getBoundingClientRect().width/unitWidth));
        for(let i=1;i<count;i++) cycle.append(clone(unit));
        this.style.setProperty('--yt-distance',cycle.getBoundingClientRect().width+'px');
        track.append(clone(cycle));
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yumi-editorial-accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const transitions = new WeakMap();
    const animateRow = (details, expand) => {
      const summary = details.querySelector(':scope > summary');
      if (!summary) return;
      const previous = transitions.get(details);
      const from = details.getBoundingClientRect().height;
      if (previous) previous.animation.cancel();
      transitions.delete(details);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        details.removeAttribute('data-yea-animating');
        details.removeAttribute('data-yea-closing');
        details.open = expand;
        return;
      }

      details.toggleAttribute('data-yea-closing', !expand);
      details.open = true;
      details.setAttribute('data-yea-animating', '');
      const style = getComputedStyle(details);
      const closedHeight = summary.getBoundingClientRect().height +
        parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth) +
        parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
      const to = expand ? details.getBoundingClientRect().height : closedHeight;
      const animation = details.animate(
        [{ height: `${from}px` }, { height: `${to}px` }],
        { duration: 700, easing: 'cubic-bezier(.075, .82, .165, 1)', fill: 'both' }
      );
      const transition = { animation, expand };
      transitions.set(details, transition);
      animation.onfinish = () => {
        if (transitions.get(details) !== transition) return;
        details.open = expand;
        details.removeAttribute('data-yea-animating');
        details.removeAttribute('data-yea-closing');
        transitions.delete(details);
        animation.cancel();
      };
    };
    const closeOtherRows = (details) => {
      details.closest('.yea').querySelectorAll('.accordion .details').forEach((other) => {
        if (other === details) return;
        const state = transitions.get(other);
        if (state ? state.expand : other.open) animateRow(other, false);
      });
    };
    // Delegation also covers sections and rows re-rendered in the theme editor.
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const summary = event.target.closest('.yea .accordion .details > summary');
      if (!summary || event.defaultPrevented) return;
      const details = summary.parentElement;
      if (!(details instanceof HTMLDetailsElement)) return;
      event.preventDefault();
      const previous = transitions.get(details);
      const expand = !(previous ? previous.expand : details.open);
      if (expand) closeOtherRows(details);
      animateRow(details, expand);
    }, true);
    // Honor exclusivity when the editor or native breakpoint logic opens a row too.
    document.addEventListener('toggle', (event) => {
      const details = event.target;
      if (details instanceof HTMLDetailsElement && details.matches('.yea .accordion .details') &&
          details.open && !transitions.has(details)) closeOtherRows(details);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
